import React, { useEffect, useMemo, useState } from "react";
import { Button, Checkbox, Form, Input, Flex, Progress, Dropdown } from "antd";
import Search from "antd/es/input/Search";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function FormHeaderComponent({
  title,
  shouldShowListButton = true,
  isShowRightButton = true,
  listRoute = "",
  extraParams = {},
}) {
  const [currentTitle, setCurrentTitle] = useState([]);
  const navigate = useNavigate();

  useMemo(() => {
    if (title !== undefined) {
      const tempTitle = title.split(" ");
      setCurrentTitle(tempTitle);
    }
  }, [title]);

  function onHandleListRoute(route) {
    const tempRoute = String(route);
    if (tempRoute === "") return;
    if (tempRoute.includes("#")) {
      const [url, scrollToSection] = tempRoute.split("#");
      navigate(url, { state: { scrollTo: scrollToSection } });
      return;
    }
    navigate(tempRoute);
  }

  return (
    <div className="flex flex-row mb-[16px] font-uregular py-[16px] w-full items-center justify-between">
      <div className="text-xl font-p_bold">{title}</div>
      {isShowRightButton && (
        <div className="flex flex-row">
          <div
            className="px-[16px] py-[8px] rounded bg-yellow text-md font-ubold cursor-pointer"
            onClick={() => onHandleListRoute(listRoute)}
          >
            List
          </div>
        </div>
      )}
    </div>
  );
}

export default FormHeaderComponent;
